// extracted by mini-css-extract-plugin
export default {"list":"AttachmentChipsList_list__ovWUR","chip":"AttachmentChipsList_chip__zT7xa"};